import { ZepQuizApiError } from '@/api';

export const isZepQuizApiError = (error: unknown): error is ZepQuizApiError => {
  return error instanceof ZepQuizApiError;
};

export const validateZepQuizApiErrorStatus = (
  error: unknown,
  statusList: string[],
) => {
  if (isZepQuizApiError(error)) {
    return {
      isError: statusList.includes(error.status),
      status: error.status,
      serverMessage: error.message,
    };
  }
};

// 더 명확한 이름의 헬퍼 함수들
export const matchesApiErrorStatus = (
  error: unknown,
  status: string | string[],
): boolean => {
  if (!isZepQuizApiError(error)) return false;
  const statusList = Array.isArray(status) ? status : [status];
  return statusList.includes(error.status);
};

export const getApiErrorStatus = (error: unknown): string | undefined => {
  if (isZepQuizApiError(error)) {
    return error.status;
  }
  return undefined;
};
